import { SeatStatus } from 'types/Location'

const COLORS = {
    available: '#00AC11',
    reserved: '#FF5733',
    selected: '#F4C000',
    notAvailable: '#FFFFFF',
}

export const SeatColors: Record<SeatStatus, string> = {
    [SeatStatus.NotAvailable]: COLORS.notAvailable,
    [SeatStatus.Complimentary]: COLORS.reserved,
    [SeatStatus.Arrived]: COLORS.reserved,
    [SeatStatus.Reserved]: COLORS.reserved,
    [SeatStatus.InPayment]: COLORS.reserved,
    [SeatStatus.Sold]: COLORS.reserved,
    [SeatStatus.Selected]: COLORS.selected,
    [SeatStatus.Available]: COLORS.available,
}
